(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    var wrapper = btn.closest('[data-variant-id]');
    if (!wrapper) return;
    var variantId = wrapper.getAttribute('data-variant-id');
    if (btn.disabled) return;
    var quantity = parseInt(wrapper.getAttribute('data-quantity'), 10) || 1;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.adding || 'Adding…';

    fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (res) {
        // /cart/add.js answers 422 with a JSON error (e.g. variant sold out): not a success.
        if (!res.ok) throw new Error('add failed: ' + res.status);
        return res.json();
      })
      .then(function () {
        btn.textContent = window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.added || 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          // The product page may have switched size meanwhile and already set the right
          // label/disabled state for the new variant; only restore if nothing changed.
          if (wrapper.getAttribute('data-variant-id') !== variantId) return;
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = window.FIORENCI_STRINGS && window.FIORENCI_STRINGS.tryAgain || 'Try again';
        btn.disabled = false;
      });
  });
})();
